<template>
  <div>
    <div class="d-flex gap-3">
      <component :is="headerComponent">
        {{ title }}
      </component>
      <span class="text-negative-600" v-if="required">*</span>
      <bp-tooltip v-if="tooltip" :text="tooltip">
        <bp-icon
          :size="tooltipIconSize"
          icon="fa-light fa-info-circle"
          class="text-neutral-500"
        />
      </bp-tooltip>
    </div>
    <div class="mt-3 text-neutral-400" v-if="subtitle" :class="subtitleClasses">
      {{ subtitle }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: "xl"
    },
    required: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    }
  },
  computed: {
    headerComponent() {
      const sizes = {
        xl: "h2",
        lg: "h3",
        md: "h4",
        sm: "div"
      };
      return sizes[this.size];
    },
    tooltipIconSize() {
      const sizes = {
        xl: 20,
        lg: 18,
        md: 16,
        sm: 14
      };
      return sizes[this.size];
    },
    subtitleClasses() {
      const sizes = {
        xl: "",
        lg: "functional-1",
        md: "functional-2",
        sm: "functional-2"
      };
      return sizes[this.size];
    }
  }
};
</script>
